import { fetchAllPages } from '../../../utils/fetchAllPages';
import { SalesMetroAdapters } from '../adapters';
import { SalesMetrosApi, SALES_METROS_MAX_PAGE, SALES_METROS_PAGE_LIMIT } from '../clients';

/**
 * Every row of the sales metro list, raw. Paged to exhaustion, not truncated —
 * both readers below have no pagination of their own to fall back on.
 * `SALES_METROS_MAX_PAGE` caps the fan-out at the last page the endpoint will
 * serve, since past it the handler 422s rather than answering empty.
 */
const fetchAllSalesMetroRows = () =>
  fetchAllPages(SalesMetrosApi.getSalesMetros, {
    limit: SALES_METROS_PAGE_LIMIT,
    maxPage: SALES_METROS_MAX_PAGE,
  });

/**
 * The whole sales metro list, as the RAM dropdowns read it.
 *
 * The list backs dropdowns with no pagination of their own, so a short read
 * would leave metros missing from a filter with no error. The reserved
 * Unassigned row is dropped (see `toSalesMetros`).
 *
 * @returns {Promise<import('../types/SalesMetro').ISalesMetro[]>}
 */
export const getSalesMetros = async () =>
  SalesMetroAdapters.toSalesMetros(await fetchAllSalesMetroRows());

/**
 * The whole sales metro list, as the Sales Metros page manages it (GOTU-6009).
 *
 * Unlike `getSalesMetros`, this keeps the reserved Unassigned row: here it is a
 * metro admins can be assigned to like any other, not a filter value the
 * monolith cannot resolve. Rows without an id are still dropped — there is
 * nothing to address an edit to.
 *
 * @returns {Promise<import('../types/SalesMetro').ISalesMetro[]>}
 */
export const listSalesMetrosForManagement = async () =>
  (await fetchAllSalesMetroRows())
    .filter((model) => model?.id)
    .map(SalesMetroAdapters.toSalesMetro);
